/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestConvexBooster extends Contract<ITestConvexBooster> {
  deposit: Send<(_pid: BigNumberish, _amount: BigNumberish, _stake: boolean) => boolean, ITestConvexBooster>
  'deposit(uint256,uint256,bool)': Send<(_pid: BigNumberish, _amount: BigNumberish, _stake: boolean) => boolean, ITestConvexBooster>
  poolInfo: Call<(_pid: BigNumberish) => { lptoken: string, token: string, gauge: string, crvRewards: string, stash: string, shutdown: boolean }, ITestConvexBooster>
  'poolInfo(uint256)': Call<(_pid: BigNumberish) => { lptoken: string, token: string, gauge: string, crvRewards: string, stash: string, shutdown: boolean }, ITestConvexBooster>
}

let ITestConvexBoosterBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestConvexBoosterBytecode = '0x';
}

// prettier-ignore
export const ITestConvexBooster = contract<ITestConvexBooster>(ITestConvexBoosterBytecode)`
  function deposit(uint256 _pid, uint256 _amount, bool _stake) returns (bool success_)
  function poolInfo(uint256 _pid) view returns (tuple(address lptoken, address token, address gauge, address crvRewards, address stash, bool shutdown) info_)
`;